import { CommonModule } from '@angular/common';
import { Component, inject, TemplateRef } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-quality-mode',
  imports: [MatButtonModule, CommonModule],
  templateUrl: './quality-mode.component.html',
  styleUrl: './quality-mode.component.scss'
})
export class QualityModeComponent {
  readonly dialog = inject(MatDialog);

  constructor() { }

  Openguardianprofile(modalTemplate: TemplateRef<any>) {
    this.dialog.open(modalTemplate, {
      autoFocus: false
    });
  }
}